export default "__VITE_PUBLIC_ASSET__bb202e7f__"